@if (!canAccessBots()) {
  <app-login />
} @else {
  <div
    class="flex h-screen w-screen bg-white dark:bg-black text-gray-900 dark:text-gray-100 overflow-hidden font-sans transition-colors duration-300"
    [style.background-image]="
      entraBranding()?.backgroundImageUrl
        ? 'url(' + entraBranding()!.backgroundImageUrl + ')'
        : null
    "
    [class.bg-cover]="entraBranding()?.backgroundImageUrl"
    [class.bg-center]="entraBranding()?.backgroundImageUrl"
  >
    <aside
      class="bg-white dark:bg-black border-r border-gray-200 dark:border-white/10 flex flex-col transition-all duration-300 flex-shrink-0 z-20"
      [ngClass]="{
        'w-[280px]': isSidebarExpanded(),
        'w-[80px]': !isSidebarExpanded(),
      }"
    >
      <div
        class="h-20 flex items-center px-6 flex-shrink-0 gap-2"
        [class.justify-center]="!isSidebarExpanded()"
        [class.justify-between]="isSidebarExpanded()"
      >
        @if (isSidebarExpanded()) {
          <div class="min-w-0">
            @if (entraBranding()?.bannerLogoUrl) {
              <img
                [src]="entraBranding()!.bannerLogoUrl"
                alt="Logo de la organización"
                class="max-h-9 max-w-[190px] object-contain object-left"
              />
            } @else {
              <h1 class="text-2xl font-bold tracking-tighter">
                M31
                <span class="text-ionet-500 text-sm align-top ml-1">{{
                  planTierLabel()
                }}</span>
              </h1>
            }
            <p
              class="text-[10px] text-gray-500 font-mono tracking-widest mt-1 uppercase"
            >
              Espacio Activo
            </p>
          </div>
        } @else {
          <button
            (click)="toggleSidebar()"
            title="Mostrar el menú lateral"
            aria-label="Mostrar el menú lateral"
            [attr.aria-expanded]="false"
            class="group flex h-10 w-10 items-center justify-center rounded-lg hover:bg-gray-100 dark:hover:bg-white/5 transition-colors"
          >
            @if (entraBranding()?.squareLogoUrl) {
              <img
                [src]="entraBranding()!.squareLogoUrl"
                alt="Logo de la organización"
                class="h-9 w-9 rounded object-contain"
              />
            } @else {
              <span class="text-xl font-bold">M31</span>
            }
          </button>
        }
      </div>

      <nav class="flex-1 overflow-y-auto px-4 mt-2 custom-scrollbar space-y-6">
        <div>
          @if (isSidebarExpanded() && agents.length > 0) {
            <h3
              class="px-2 text-[11px] font-bold text-gray-400 uppercase tracking-widest font-mono mb-2"
            >
              Agentes Activos
            </h3>
          }

          @for (item of agents; track item.id) {
            <button
              (click)="selectNavItem(item)"
              [title]="item.label"
              class="w-full flex items-center relative h-12 rounded-lg px-3 mb-1 transition-all group"
              [ngClass]="{
                '': activeNavItem() === item && !isDarkMode(),
                'bg-white/5': activeNavItem() === item && isDarkMode(),
                'border-ionet-500': activeNavItem() === item,
              }"
            >
              @if (activeNavItem() === item) {
                <div
                  class="absolute left-0 inset-y-0 w-1 bg-ionet-500 rounded-r-full shadow-[0_0_15px_rgba(16,185,129,0.8)]"
                ></div>
              }
              <span
                class="w-2.5 h-2.5 rounded-full flex-shrink-0 {{
                  item.dotColor
                }}"
                [ngClass]="{
                  'opacity-80 animate-pulse': activeNavItem() === item,
                  'opacity-45': activeNavItem() !== item,
                }"
              ></span>
              @if (isSidebarExpanded()) {
                <span
                  class="ml-3 text-sm font-medium truncate transition-colors"
                  [class.text-gray-900]="
                    activeNavItem() === item && !isDarkMode()
                  "
                  [class.text-white]="activeNavItem() === item && isDarkMode()"
                  [class.text-gray-500]="activeNavItem() !== item"
                >
                  {{ item.label }}
                </span>
              }
            </button>
          }
        </div>

        @if (avatares.length > 0) {
          <div class="pt-2">
            @if (isSidebarExpanded()) {
              <h3
                class="px-2 text-[11px] font-bold text-violet-500 dark:text-violet-400 uppercase tracking-widest font-mono mb-2"
              >
                Avatar IA
              </h3>
            }
            @for (item of avatares; track item.id) {
              <button
                (click)="selectNavItem(item)"
                [title]="item.label"
                class="w-full flex items-center relative h-12 rounded-lg px-3 mb-1 transition-all group"
                [ngClass]="{
                  '': activeNavItem() === item && !isDarkMode(),
                  'bg-white/5': activeNavItem() === item && isDarkMode(),
                  'border-violet-500': activeNavItem() === item,
                }"
              >
                @if (activeNavItem() === item) {
                  <div
                    class="absolute left-0 inset-y-0 w-1 bg-violet-500 rounded-r-full"
                  ></div>
                }
                <span
                  class="w-2.5 h-2.5 rounded-full flex-shrink-0 bg-violet-500"
                  [ngClass]="{
                    'opacity-80 animate-pulse': activeNavItem() === item,
                    'opacity-45': activeNavItem() !== item,
                  }"
                ></span>
                @if (isSidebarExpanded()) {
                  <span
                    class="ml-3 text-sm font-medium truncate transition-colors"
                    [class.text-gray-900]="
                      activeNavItem() === item && !isDarkMode()
                    "
                    [class.text-white]="
                      activeNavItem() === item && isDarkMode()
                    "
                    [class.text-gray-500]="activeNavItem() !== item"
                  >
                    {{ item.label }}
                  </span>
                }
              </button>
            }
          </div>
        }

        @if (betas.length > 0) {
          <div class="pt-2">
            @if (isSidebarExpanded()) {
              <div class="mb-2 px-2 flex items-center gap-2">
                <span
                  class="text-[10px] font-bold text-amber-500 bg-amber-50 dark:bg-amber-900/20 px-1.5 py-0.5 rounded border border-amber-200 dark:border-amber-800 uppercase tracking-widest"
                  >Beta</span
                >
              </div>
            }
            @for (item of betas; track item.id) {
              <button
                (click)="selectNavItem(item)"
                [title]="item.label"
                class="w-full flex items-center h-10 rounded-lg px-3 mb-1 hover:bg-gray-50 dark:hover:bg-white/5 transition-all group"
                [ngClass]="{
                  'bg-amber-50': activeNavItem() === item && !isDarkMode(),
                  'bg-white/5': activeNavItem() === item && isDarkMode(),
                }"
              >
                <div
                  class="w-2 h-2 rounded-full bg-amber-400 flex-shrink-0"
                  [class.animate-pulse]="activeNavItem() === item"
                ></div>
                @if (isSidebarExpanded()) {
                  <span
                    class="ml-3 text-sm font-medium truncate text-gray-600 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white transition-colors"
                    >{{ item.label }}</span
                  >
                }
              </button>
            }
          </div>
        }

        @if (tools.length > 0) {
          <div class="pt-2">
            @if (isSidebarExpanded()) {
              <h3
                class="px-2 text-[11px] font-bold text-teal-600 dark:text-teal-500 uppercase tracking-widest font-mono mb-2 flex items-center gap-2"
              >
                Azure Creative
              </h3>
            }
            @for (item of tools; track item.id) {
              <button
                (click)="selectNavItem(item)"
                [title]="item.label"
                class="w-full flex items-center h-10 rounded-lg px-3 mb-1 hover:bg-gray-50 dark:hover:bg-white/5 transition-all group"
                [ngClass]="{
                  'bg-teal-50': activeNavItem() === item && !isDarkMode(),
                  'bg-white/5': activeNavItem() === item && isDarkMode(),
                }"
              >
                <svg
                  class="w-4 h-4 text-gray-400 group-hover:text-teal-500 transition-colors flex-shrink-0"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                    [attr.d]="item.iconPath"
                  />
                </svg>
                @if (isSidebarExpanded()) {
                  <span
                    class="ml-3 text-sm font-medium truncate text-gray-600 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white transition-colors"
                    >{{ item.label }}</span
                  >
                }
              </button>
            }
          </div>
        }
      </nav>

      <div
        class="p-4 border-t border-gray-200 dark:border-white/10 mt-auto bg-white dark:bg-black z-10 relative"
      >
        <button
          (click)="toggleUserMenu()"
          title="Tu cuenta y cierre de sesión"
          aria-label="Tu cuenta y cierre de sesión"
          class="flex items-center gap-3 w-full p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-white/5 transition-colors"
        >
          <div
            class="w-10 h-10 rounded bg-ionet-100 dark:bg-ionet-900/20 flex items-center justify-center overflow-hidden text-ionet-600 font-bold border border-ionet-200 flex-shrink-0"
          >
            @if (userProfile().photoUrl; as photoUrl) {
              <img
                [src]="photoUrl"
                [alt]="'Foto de ' + userProfile().name"
                class="h-full w-full object-cover"
                (error)="authService.clearProfilePhoto()"
              />
            } @else {
              {{ userProfile().initials }}
            }
          </div>
          @if (isSidebarExpanded()) {
            <div class="text-left overflow-hidden">
              <p class="text-sm font-bold truncate">{{ userProfile().name }}</p>
              <p
                class="text-[10px] text-gray-500 uppercase tracking-tighter truncate"
              >
                {{ userProfile().companyName || userProfile().level }}
              </p>
            </div>
          }
        </button>

        @if (isUserMenuOpen()) {
          <!-- Capa transparente: un clic en cualquier otro punto cierra el menú. -->
          <div class="fixed inset-0 z-20" (click)="closeUserMenu()"></div>

          <div
            class="absolute bg-white dark:bg-zinc-900 border border-gray-200 dark:border-white/10 rounded-xl shadow-xl p-2 z-30"
            [ngClass]="{
              'bottom-20 left-4 right-4': isSidebarExpanded(),
              'bottom-6 left-full ml-2 w-60': !isSidebarExpanded(),
            }"
          >
            @if (consumoPropioActivo) {
            <div class="px-2 pt-1 pb-2">
              <p
                class="flex items-center gap-1.5 text-[10px] font-semibold uppercase tracking-widest text-gray-400 dark:text-gray-500"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                  aria-hidden="true"
                >
                  <defs>
                    <!-- Gradiente cian a púrpura para el texto y acentos -->
                    <linearGradient
                      id="tokenGradient"
                      x1="0%"
                      y1="0%"
                      x2="100%"
                      y2="100%"
                    >
                      <stop offset="0%" stop-color="#22d3ee" />
                      <stop offset="100%" stop-color="#c084fc" />
                    </linearGradient>
                  </defs>
                  <!-- Anillos concéntricos estilo token/cripto -->
                  <circle
                    cx="12"
                    cy="12"
                    r="10"
                    fill="none"
                    stroke="url(#tokenGradient)"
                    stroke-width="1.2"
                    opacity="0.8"
                  />
                  <circle
                    cx="12"
                    cy="12"
                    r="8.2"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1"
                    opacity="0.3"
                    stroke-dasharray="2 1.5"
                  />
                  <!-- Nodos de conexión (superior e inferior) -->
                  <circle cx="12" cy="2" r="1" fill="url(#tokenGradient)" />
                  <circle cx="12" cy="22" r="1" fill="url(#tokenGradient)" />
                  <circle
                    cx="2"
                    cy="12"
                    r="0.8"
                    fill="currentColor"
                    opacity="0.5"
                  />
                  <circle
                    cx="22"
                    cy="12"
                    r="0.8"
                    fill="currentColor"
                    opacity="0.5"
                  />
                  <!-- Identificador M31 -->
                  <text
                    x="12"
                    y="15.2"
                    font-family="'Inter', 'Segoe UI', system-ui, sans-serif"
                    font-weight="900"
                    font-size="8.5"
                    text-anchor="middle"
                    fill="url(#tokenGradient)"
                    letter-spacing="-0.5"
                  >
                    M31
                  </text>
                </svg>
                <span>Tus tokens</span>
              </p>

              @if (consumoPropioCargando()) {
                <p class="mt-2 text-xs text-gray-400">Calculando…</p>
              } @else if (consumoPropioError()) {
                <p class="mt-2 text-xs text-gray-400">
                  No se pudo obtener tu consumo.
                </p>
              } @else if (consumoPropio(); as consumo) {
                <div class="mt-2 flex items-center gap-2">
                  <div
                    class="flex flex-1 items-center gap-1.5 rounded-lg bg-gray-50 dark:bg-white/5 px-2.5 py-2"
                    title="Tokens de entrada: lo que tú envías a los agentes"
                  >
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2.5"
                      class="h-3.5 w-3.5 shrink-0 text-emerald-500"
                      aria-hidden="true"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M12 19V5m0 0-6 6m6-6 6 6"
                      />
                    </svg>
                    <span
                      class="text-sm font-semibold tabular-nums text-gray-900 dark:text-white"
                      >{{ formatearTokens(consumo.inputTokens) }}</span
                    >
                    <span class="sr-only">tokens de entrada</span>
                  </div>
                  <div
                    class="flex flex-1 items-center gap-1.5 rounded-lg bg-gray-50 dark:bg-white/5 px-2.5 py-2"
                    title="Tokens de salida: lo que los agentes te responden"
                  >
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2.5"
                      class="h-3.5 w-3.5 shrink-0 text-sky-500"
                      aria-hidden="true"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M12 5v14m0 0 6-6m-6 6-6-6"
                      />
                    </svg>
                    <span
                      class="text-sm font-semibold tabular-nums text-gray-900 dark:text-white"
                      >{{ formatearTokens(consumo.outputTokens) }}</span
                    >
                    <span class="sr-only">tokens de salida</span>
                  </div>
                </div>
                <p class="mt-2 text-[10px] text-gray-400 dark:text-gray-500">
                  {{ formatearTokens(consumo.messages) }} mensajes en total
                </p>
              }
            </div>

            <div class="my-1 h-px bg-gray-100 dark:bg-white/10"></div>
            }

            <button
              (click)="logout()"
              class="w-full flex items-center gap-3 p-2 text-red-500 hover:bg-red-50 dark:hover:bg-red-900/10 rounded-lg transition-colors text-sm font-medium whitespace-nowrap"
            >
              <svg
                class="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                />
              </svg>
              <span class="flex-shrink-0">Cerrar Sesión</span>
            </button>
          </div>
        }
      </div>
    </aside>

    @if (activeNavItem(); as active) {
      <main
        class="flex-1 flex flex-col h-full w-full bg-white dark:bg-black relative overflow-hidden"
      >
        <header
          class="h-16 flex items-center justify-between px-6 border-b border-gray-200 dark:border-white/10 flex-shrink-0 bg-white dark:bg-black z-10"
        >
          <div class="flex items-center gap-4">
            <button
              (click)="toggleSidebar()"
              [title]="
                isSidebarExpanded()
                  ? 'Ocultar el menú lateral'
                  : 'Mostrar el menú lateral'
              "
              [attr.aria-label]="
                isSidebarExpanded()
                  ? 'Ocultar el menú lateral'
                  : 'Mostrar el menú lateral'
              "
              [attr.aria-expanded]="isSidebarExpanded()"
              class="text-gray-400 hover:text-gray-900 dark:hover:text-white transition-colors"
            >
              <svg
                class="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.5"
                  d="M3.75 6.75h16.5M3.75 12h16.5M3.75 17.25h16.5"
                />
              </svg>
            </button>
            <h2 class="text-lg font-semibold">{{ active.label }}</h2>
          </div>

          <div class="flex items-center gap-3">
            <button
              (click)="toggleTheme()"
              [title]="
                isDarkMode() ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'
              "
              [attr.aria-label]="
                isDarkMode() ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'
              "
              class="p-2 text-gray-400 hover:text-gray-900 dark:hover:text-white transition-colors"
            >
              @if (isDarkMode()) {
                <svg
                  class="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                    d="M12 3v2.25m6.364.386l-1.591 1.591M21 12h-2.25m-.386 6.364l-1.591-1.591M12 18.75V21m-4.773-4.227l-1.591 1.591M3 12h2.25m.386-6.364l1.591 1.591M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z"
                  />
                </svg>
              } @else {
                <svg
                  class="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                    d="M21.752 15.002A9.718 9.718 0 0118 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 003 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 009.002-5.998z"
                  />
                </svg>
              }
            </button>
            <span
              [ngClass]="
                active.isComingSoon
                  ? 'text-amber-600 bg-amber-50 border-amber-200'
                  : active.type === 'anam'
                    ? 'text-violet-600 bg-violet-50 border-violet-200'
                    : active.type === 'custom'
                      ? ''
                      : 'text-ionet-600 bg-ionet-50 border-ionet-200'
              "
              class="text-xs px-2 py-1 rounded border dark:bg-white/5 dark:border-white/10 dark:text-gray-300"
            >
              @if (active.isComingSoon) {
                Próximamente
              } @else if (active.type === "anam") {
                Avatar IA
              } @else if (active.type === "custom") {
                @if (active.sidebarIconUrl) {
                  <img
                    [src]="active.sidebarIconUrl"
                    [alt]="active.sidebarIconAlt || active.label"
                    class="w-6 h-6"
                  />
                } @else {
                  Custom
                }
              } @else if (active.type === "agent") {
                Agente Activo
              } @else {
                Herramienta
              }
            </span>
          </div>
        </header>

        <div
          class="flex-1 relative w-full h-full overflow-hidden p-4 bg-gray-50/30 dark:bg-zinc-900/20"
        >
          @if (!isChatResetting()) {
            <div
              class="h-full w-full bg-white dark:bg-black rounded-2xl shadow-sm border border-gray-200 dark:border-white/10 overflow-hidden flex flex-col"
            >
              @if (active.isComingSoon) {
                <app-coming-soon [featureName]="active.label" />
              } @else if (active.type === "anam") {
                <app-anam-agent class="flex-1 h-full" />
              } @else if (active.type === "custom") {
                <app-custom-foundry-chat
                  class="flex-1 h-full"
                  [agentId]="active.id"
                  [title]="active.chatConfig.title"
                ></app-custom-foundry-chat>
              }
            </div>
          } @else {
            <div class="h-full w-full flex items-center justify-center">
              <div
                class="w-8 h-8 border-2 border-ionet-500 rounded-full animate-spin"
              ></div>
            </div>
          }
        </div>
      </main>
    } @else if (isLoggedIn()) {
      <main
        class="flex-1 h-full w-full overflow-y-auto bg-gray-50/50 dark:bg-zinc-900/10"
      >
        <div
          class="min-h-full flex flex-col items-center justify-center px-6 py-16"
        >
          <div class="w-full max-w-2xl welcome-enter">
            <div class="flex flex-col items-center text-center">
              @if (logoHome(); as logo) {
                <!-- Entró por la ruta de un cliente: se muestra su logo, no el de M31. -->
                <div class="welcome-logo-cliente inline-flex items-center justify-center">
                  <img
                    [src]="logo"
                    alt="Logotipo de tu organización"
                    referrerpolicy="no-referrer"
                    class="block max-h-14 max-w-[220px] object-contain"
                    (error)="logoClienteFalla(logo)"
                  />
                </div>
              } @else {
              <div
                class="welcome-logo w-20 h-20 rounded-2xl flex items-center justify-center"
              >
                <img
                  src="https://m31ai.com/assets/img/logo-m31-suite-blanco.png"
                  alt="M31 Suite"
                  class="w30 h-30 object-contain"
                />
              </div>
              }

              <h1
                class="mt-6 text-3xl sm:text-4xl font-semibold tracking-[-0.02em] leading-[1.08] text-gray-900 dark:text-white"
              >
                {{ welcomeGreeting }}, {{ welcomeName() }}
              </h1>

              @if (agents.length > 0) {
                <p
                  class="mt-3 text-[15px] leading-relaxed text-gray-500 dark:text-gray-400"
                >
                  Elige con quién quieres trabajar.
                </p>
              } @else {
                <p
                  class="mt-3 max-w-sm text-[15px] leading-relaxed text-gray-500 dark:text-gray-400"
                >
                  Tu cuenta no tiene agentes inteligentes activos. Contacta a
                  soporte para habilitarlos.
                </p>
                <button
                  (click)="logout()"
                  class="welcome-card mt-8 rounded-full px-5 py-2.5 text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-white/[0.04] ring-1 ring-black/5 dark:ring-white/10 shadow-sm"
                >
                  Entrar con otra cuenta
                </button>
              }
            </div>

            @if (agents.length > 0) {
              <div class="mt-10 grid gap-3 sm:grid-cols-2">
                @for (item of agents; track item.id) {
                  <button
                    type="button"
                    (click)="selectNavItem(item)"
                    class="welcome-card group flex items-center gap-4 rounded-2xl bg-white dark:bg-white/[0.03] p-4 text-left ring-1 ring-black/5 dark:ring-white/10 shadow-sm"
                  >
                    <span
                      class="relative flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-gray-50 dark:bg-white/[0.06] ring-1 ring-black/5 dark:ring-white/10"
                    >
                      @if (item.sidebarIconUrl) {
                        <img
                          [src]="item.sidebarIconUrl"
                          [alt]="item.sidebarIconAlt || item.label"
                          class="h-6 w-6 object-contain"
                        />
                      } @else {
                        <span
                          class="h-2.5 w-2.5 rounded-full {{ item.dotColor }}"
                        ></span>
                      }
                    </span>

                    <span class="min-w-0 flex-1">
                      <span
                        class="block truncate text-[15px] font-medium text-gray-900 dark:text-white"
                        >{{ item.label }}</span
                      >
                      <span
                        class="mt-0.5 block text-xs text-gray-400 dark:text-gray-500"
                        >Iniciar conversación</span
                      >
                    </span>

                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="2"
                      stroke="currentColor"
                      class="welcome-chevron h-4 w-4 shrink-0 text-gray-300 dark:text-gray-600"
                      aria-hidden="true"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="m8.25 4.5 7.5 7.5-7.5 7.5"
                      />
                    </svg>
                  </button>
                }
              </div>

              <p
                class="mt-8 text-center text-xs text-gray-400 dark:text-gray-500"
              >
                Puedes cambiar de agente cuando quieras desde el menú lateral.
              </p>
            }
          </div>
        </div>
      </main>
    }
  </div>
}
